import React from 'react'
import "./real.css";
import Topheader from '../topheader/Topheader'
import Navcivil from '../navbar/Navcivil';
import image from "../../assets/banner-image/real-estate.jpeg";
import real1 from "../../assets/realestate/real1.jpeg";
import real2 from "../../assets/realestate/real2.jpeg";
import real3 from "../../assets/realestate/real3.jpeg";
import Footer from "../footer/Footer";

function Realestate() {
  return (
    <>
      <Topheader />
      <Navcivil />
      <section>
        <div className="image-about">      
          <img src={image} alt="About Us" className="image-bg" />        
          <div className="overlay-about">
            <h1 className="fade-in-text">Real-Estate</h1>
          </div>
        </div>
      </section>

      <div className="about-us-container">
        <div className="about-us-content">
          <div className="left-side">
            <h3>REAL ESTATE</h3>
            <div className="underline"></div>
            <h4 style={{ textAlign: "center",color:"#FDC30B" }}>First Sky Infrastructure</h4>
            <p style={{ textAlign: "justify" }}>
              First Sky Infra could be a real estate company  that deals with the buying, selling, renting, and management of properties, including residential, commercial, and industrial spaces.
            </p>
            <ul>
              <li>Property Sales and Purchases</li>
              <li>Property Purchases</li>
              <li>Land Transactions</li>
              <li>Brokerage and Mediation</li>
            </ul>
          </div>

          <div className="right-side">
            <div className="image-container">
              <img src={real2} alt="Construction Site" className="large-image" />
            </div>
          </div>
        </div>
      </div>

      <div className="container vm-conatiner" >
        <div className="image-container-vm">
          <img src={real1} alt="Your Image" className="image-vm" />
        </div>
        <div className="text-container">
          <div className="vision">
            <h4>Property Sales and Purchases:</h4>
            <p style={{ textIndent: "30px", textAlign: "justify" }}>
              First Sky Infra may assist property owners in selling residential, commercial, or industrial properties. This includes evaluating the property, marketing it to potential buyers, negotiating deals, and ensuring legal compliance throughout the process.
            </p>
            <h4>Property Purchases:</h4>
            <p style={{ textIndent: "30px", textAlign: "justify" }}>
              The company might help buyers find suitable properties according to their preferences, whether for personal use, business, or investment. They could assist with the search, price negotiations, and the legal and financial processes involved in property acquisitions.
            </p>
          </div>
         
        </div>
      </div>
      
      <div className="about-us-container" style={{ marginTop:"0px"}}>
        <div className="about-us-content">
          <div className="left-side">
            <h4>Land Transactions:</h4>
            <p style={{ textIndent: "30px", textAlign: "justify" }}>
              First Sky Infra might also be involved in buying and selling land for development, either for its own projects or on behalf of clients.                </p>
            <h4>Brokerage and Mediation:</h4>
            <p style={{ textIndent: "30px", textAlign: "justify" }}>
              Acting as intermediaries between buyers and sellers, helping negotiate deals, and finalizing transactions while ensuring that both parties are satisfied.                </p>
          </div>
          <div className="right-side">
            <div className="image-container">
              <img src={real3} alt="Construction Site" className="large-image" />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default Realestate